var _defs, _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_1828",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#4e4e57}\n        "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_100",
    cx: 1.286,
    cy: 1.286,
    r: 1.286,
    className: "cls-1",
    transform: "translate(8.197 8.357)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    cx: 1.286,
    cy: 1.286,
    r: 1.286,
    className: "cls-1",
    transform: "translate(16.232 8.357)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6685",
    d: "M20.428 26a6.75 6.75 0 0 0-6.4 4.294.644.644 0 0 0 1.221.411 5.361 5.361 0 0 1 5.175-3.42 5.361 5.361 0 0 1 5.143 3.42.643.643 0 0 0 .643.437.8.8 0 0 0 .206 0 .643.643 0 0 0 .437-.849A6.75 6.75 0 0 0 20.428 26z",
    className: "cls-1",
    transform: "translate(-6.928 -11.213)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6686",
    d: "M16.5 3A13.5 13.5 0 1 0 30 16.5 13.5 13.5 0 0 0 16.5 3zm0 25.714A12.214 12.214 0 1 1 28.715 16.5 12.214 12.214 0 0 1 16.5 28.714z",
    className: "cls-1",
    transform: "translate(-3 -3)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/sad.19261c01fb487727dd9c65ab347d9885.svg";
export { ForwardRef as ReactComponent };